export enum RESTRICTION_ACTION {
    NO_ACTION = 'NO_ACTION',
    RESTRICT = 'RESTRICT',
    DISABLE = 'DISABLE',
    REMOVE = 'REMOVE',
}
